// extracted by mini-css-extract-plugin
module.exports = {"totals":"CustomDonationForm_totals__X_FRi"};